import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType, URLSearchParams } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from './tools/errors.service';
import { OpcionesPago } from './tools/helpers.service';

@Injectable()
export class PagosService {

  private service_url: string = '';
  private calcService_url: string = '';
  private recibo_url: string = '';

  constructor(
    private constantsService: ConstantsService,
    private http: Http,
    private authService: AutenticacionService,
    private validatorService: ValidatorService,
    private errorService: ErrorsService
  ) {
    this.service_url = this.constantsService.apiURL + '/pagos';
    this.calcService_url = this.constantsService.apiURL + '/calculo';
    this.recibo_url = this.constantsService.apiURL + '/recibos/pago';
  }

  /**
   * Obtiene las opciones de pago para un crédito, opcionalmente excluyendo un pago para edición y aplicando descuento.
   * @param id ID del crédito
   * @param idPago ID del pago (para edición)
   * @param porcentaje_descuento Descuento aplicado (opcional)
   */
  public getOpcionesPago(id: number, idPago: number | null, porcentaje_descuento: number | null = null) {
    let myParams = new URLSearchParams();

    if (idPago) {
      myParams.append('idPagos', idPago.toString());
    }

    if (porcentaje_descuento !== null && porcentaje_descuento !== undefined) {
      myParams.append('descuento', porcentaje_descuento.toString());
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;

    const urlService = `${this.calcService_url}/opcionesPagos/${id}`;

    return this.http.get(urlService, myoptions);
  }

  public getTablaPagos(id: number) {
    return this.http.get(`${this.calcService_url}/tablaPagos/${id}`, this.authService.getAuthHeaders());
  }

  public getPago(id: number) {
    return this.http.get(`${this.service_url}/${id}`, this.authService.getAuthHeaders());
  }

  public getReciboPago(id: number, url: string) {
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    return this.http.get(`${this.recibo_url}/${id}?url=${encodeURIComponent(url)}&action=download`, options);
  }

  public save(pago: object) {
    console.info('📤 Enviando datos de pago al backend:', pago);
    return this.http.post(this.service_url, pago, this.authService.getAuthHeaders());
  }

  public update(pago: object) {
    return this.http.put(this.service_url, pago, this.authService.getAuthHeaders());
  }

  public validate(pago: any) {
    let error: any = {};

    if (!this.validatorService.required(pago.tipo) || !this.validatorService.numeric(pago.monto_pago)) {
      error["tipo"] = this.errorService.required;
    }

    if (!this.validatorService.required(pago.forma)) {
      error["forma"] = this.errorService.required;
    }

    if (!this.validatorService.required(pago.fecha)) {
      error["fecha"] = this.errorService.required;
    }

    if (!this.validatorService.numeric(pago.penalizacion)) {
      error["penalizacion"] = this.errorService.required;
    }

    if (pago.abono && +pago.abono > 0) {
      if (!this.validatorService.required(pago.tipo_abono)) {
        error["tipo_abono"] = this.errorService.required;
      }
    }

    if (pago.tipo_abono) {
      if (!this.validatorService.required(pago.abono)) {
        error["abono"] = this.errorService.required;
      }
    }

    if (pago.porcentaje_descuento && pago.porcentaje_descuento > 100) {
      error["porcentaje_descuento"] = "El descuento no puede ser mayor al 100%";
    }

    return error;
  }

  public validateDistribucion(pago: any) {
    let error: any = {};

    if (pago.tipo === OpcionesPago.Periodo && !this.validatorService.required(pago.litros_consumidos)) {
      error["litros_consumidos"] = this.errorService.required;
    }

    if (!this.validatorService.required(pago.forma)) {
      error["forma"] = this.errorService.required;
    }

    if (!this.validatorService.required(pago.fecha)) {
      error["fecha"] = this.errorService.required;
    }

    if (!this.validatorService.numeric(pago.penalizacion)) {
      error["penalizacion"] = this.errorService.required;
    }

    if (pago.porcentaje_descuento && pago.porcentaje_descuento > 100) {
      error["porcentaje_descuento"] = "El descuento no puede ser mayor al 100%";
    }

    return error;
  }

  public getPagosPendientesDelConvenio(filters: any) {
    let myParams = new URLSearchParams();

    if (filters.idConvenios) {
      myParams.append('idConvenios', filters.idConvenios);
    }

    if (filters.fecha_fin) {
      myParams.append('fecha_fin', filters.fecha_fin);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;

    let serviceUrl = `${this.service_url}/convenios/pagos-pendientes`;

    return this.http.get(serviceUrl, myoptions);
  }

  public makePayments(paymentsToDo: any) {
    let serviceUrl = `${this.service_url}/convenios/pagar`;
    return this.http.post(serviceUrl, paymentsToDo, this.authService.getAuthHeaders());
  }

  public getSubpagosPorPago(idPago: number) {
    return this.http.get(`${this.service_url}/subPagos/${idPago}`, this.authService.getAuthHeaders());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/pagos.service.ts